class OntarioObstetricalAdditionalInvestigation {
    public Test: string = "";
    public Result: string = "";

    constructor(fields?: Partial<OntarioObstetricalAdditionalInvestigation>) {
        Object.assign(this, fields);
    }
}

export { OntarioObstetricalAdditionalInvestigation };
